/*
 * Steps — Indicador de pasos / progreso
 * ─────────────────────────────────────────────────────────────────
 *
 * Props:
 *   steps        array    Requerido. Lista de pasos:
 *                           [{ label: string, description?: string, icon?: string }]
 *   direction    string   "vertical" | "horizontal"  (default: "vertical")
 *   activeStep   number   Índice del último paso completado (0-based).
 *                         -1  = ninguno completado
 *                         undefined / omitido = todos completados (default)
 *
 * Uso:
 *   // Todos completados (default)
 *   <Steps steps={[{ label: "Inicio" }, { label: "Proceso" }, { label: "Fin" }]} />
 *
 *   // Solo el primer paso completado
 *   <Steps steps={steps} activeStep={0} />
 *
 *   // Ninguno completado
 *   <Steps steps={steps} activeStep={-1} />
 *
 *   // Horizontal
 *   <Steps steps={steps} activeStep={1} direction="horizontal" />
 * ─────────────────────────────────────────────────────────────────
 */
import React from "react";
import Text from "../../Atomsv2/Text/Text";
import "./Steps.scss";

const Steps = ({ steps = [], direction = "vertical", activeStep }) => {
    const allCompleted = activeStep === undefined || activeStep === null;

    const isCompleted = (i) => allCompleted || i < activeStep;
    const isActive    = (i) => !allCompleted && i === activeStep;

    return (
        <div className={`Steps Steps--${direction}`}>
            {steps.map((step, i) => {
                const completed = isCompleted(i);
                const active    = isActive(i);
                const isLast    = i === steps.length - 1;

                return (
                    <div
                        key={i}
                        className={`step ${completed ? "step--completed" : ""} ${active ? "step--active" : ""}`}
                    >
                        {/* Indicador (número / check) + línea */}
                        <div className="step-indicator">
                            <div className="step-number">
                                {completed
                                    ? <span className="icon" data-icon="check" />
                                    : <span className="step-index">{i + 1}</span>
                                }
                            </div>
                            {!isLast && <div className={`step-line ${completed ? "step-line--done" : ""}`} />}
                        </div>

                        {/* Contenido */}
                        <div className="step-body">
                            <div className="step-header">
                                {step.icon && <span className="icon" data-icon={step.icon} />}
                                <Text weight={600} className="step-label">{step.label}</Text>
                            </div>
                            {step.description && (
                                <Text size="small" color="var(--gray-dark-600)" className="step-desc">
                                    {step.description}
                                </Text>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Steps;
